/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDateTime } from '@js-joda/core';

export enum InvestmentHoldingType {
    RealEstate = 'real_estate',
    Cash = 'cash',
    PrivateStock = 'private_stock',
    Collectables = 'collectables',
    Stock = 'stock',
    Retire = 'retire',
    College = 'college',
    Bonds = 'bonds',
    Crypto = 'crypto',
    Custom = 'custom',
    Other = 'other'
}

export enum InvestmentHoldingSubtype {
    CheckingAccount = 'checkingAccount',
    SavingAccount = 'savingAccount',
    HighYieldSavingAccount = 'highYieldSavingAccount',
    OtherCashAndBanking = 'otherCashAndBanking',
    CertificateOfDeposit = 'certificateOfDeposit',
    '401kAnd403b' = '401kAnd403b',
    Ira = 'ira',
    Pension = 'pension',
    OtherInvestmentsAndRetirement = 'otherInvestmentsAndRetirement',
    RealEstate = 'realEstate',
    Vehicles = 'vehicles'
}

export class InvestmentHoldingModel {
    id?: number;
    type: string;
    subtype?: InvestmentHoldingSubtype;
    name: string;
    ticker?: string;
    symbol?: string;
    quantity?: number;
    price?: number;
    amount: number;
    interest?: number;
    attributes?: {
        [key: string]: any;
    };

    investment_id: number;
    created: LocalDateTime;
    updated: LocalDateTime;

    static types = InvestmentHoldingType;

    public static investmentTypes = [
        ['Home, condo, or investment property', InvestmentHoldingType.RealEstate],
        ['Cash', InvestmentHoldingType.Cash],
        ['Private or illiquid stock', InvestmentHoldingType.PrivateStock],
        ['Collectables', InvestmentHoldingType.Collectables],
        ['Mutual Funds / Public Stocks', InvestmentHoldingType.Stock],
        ['Retire (401K, IRAs, etc)', InvestmentHoldingType.Retire],
        ['Education (529)', InvestmentHoldingType.College],
        ['Bonds & Debts', InvestmentHoldingType.Bonds],
        ['Crypto', InvestmentHoldingType.Crypto],
        ['Custom (vehicles, jewelry, art)', InvestmentHoldingType.Custom],
        ['Other', InvestmentHoldingType.Other]
    ];

    public static investmentTypeKeys = InvestmentHoldingModel.investmentTypes.map((investmentType) => {
        return investmentType[1];
    });
}

export class Ticker {
    ticker: string;
    price: number;
    name: string;
    lastUpdated: string;
}
